import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Icon = styled.img`
    margin-right: 8px;
    width: auto;
    height: 24px;
`

export const Message = styled.div``
